import API from "../api/apiUser";

export const UserBiographyServices = {
    getSettings: async () => {
        try {
            const response = await API.get("/user/biography/settings");
            return response.data;
        } catch (error) {
            console.error("Error fetching biography settings:", error);
            throw error;
        }
    },

    downloadBio: async () => {
        try {
            const response = await API.get("/user/biography/download", {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Temidayo_Balogun_Biography.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading biography:", error);
            throw error;
        }
    }
};
